export default `p.y+=1.4;
    
    for(int j=0;++j<9;)
      p=abs(p),
      p.xy*=rotate2D(-9.78),
      p.x<p.y?p=p.yxz:p,
      p.x<p.z?p=p.zyx:p,
      p.y<p.z?p=p.xzy:p,
      p.yz*=rotate2D(-1.16),
      p=1.9*p-vec3(1.0,1.0,-1.0);
    return length(p-clamp(p,-5.,5.))/500.;
  }`